import en from './en.js'
import zh from './zh.js'

let messages = {
  'en': en,
  'zh': zh
}

// The visitor's chosen language, shared by the app and the landing page.
// Nothing is stored until a language is actually chosen, so "no choice yet"
// stays distinguishable from "chose English" (the landing page then follows
// the browser's language). Storage can be unavailable in private windows.
const LOCALE_KEY = 'locale'

export function savedLocale () {
  try {
    const l = localStorage.getItem(LOCALE_KEY)
    return messages[l] ? l : null
  } catch (e) {
    return null
  }
}

export function saveLocale (locale) {
  try {
    localStorage.setItem(LOCALE_KEY, locale)
  } catch (e) {
    // The choice simply will not persist.
  }
}

export default messages
